"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config = {
    stage: "dev",
    photomapsApi: {
        url: "https://uesroiq08d.execute-api.us-east-1.amazonaws.com/dev"
    },
    aws: {
        region: "us-east-1",
        cognito: {
            userPoolId: "us-east-1_PzHC0YZ3E",
            appClientId: "1p49ni7cldiuifmrh4mejs6mdq",
            identityPoolId: "us-east-1:a3ebb451-9d5f-4f4c-bdb7-1b73d2776c65",
        },
    },
    shopify: {
        domain: "photomaps-com.myshopify.com",
        storefrontAccessToken: "819d35b9368de95c36bcd89f7e3138a9",
    },
};
exports.default = config;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGhvdG9tYXBzRG90Q29tQ29uZmlnLmRldi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9QaG90b21hcHNEb3RDb21Db25maWcuZGV2LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsTUFBTSxNQUFNLEdBQTBCO0lBQ3BDLEtBQUssRUFBRSxLQUFLO0lBQ1osWUFBWSxFQUFFO1FBQ1osR0FBRyxFQUFFLDREQUE0RDtLQUNsRTtJQUNELEdBQUcsRUFBRTtRQUNILE1BQU0sRUFBRSxXQUFXO1FBQ25CLE9BQU8sRUFBRTtZQUNQLFVBQVUsRUFBRSxxQkFBcUI7WUFDakMsV0FBVyxFQUFFLDRCQUE0QjtZQUN6QyxjQUFjLEVBQUUsZ0RBQWdEO1NBQ2pFO0tBQ0Y7SUFDRCxPQUFPLEVBQUU7UUFDUCxNQUFNLEVBQUUsNkJBQTZCO1FBQ3JDLHFCQUFxQixFQUFFLGtDQUFrQztLQUMxRDtDQUNGLENBQUM7QUFDRixrQkFBZSxNQUFNLENBQUMifQ==